/**
 * Small red "E" badge shown next to explicit tracks — mirrors the
 * parental-advisory sticker used across streaming platforms.
 * Renders nothing when the track isn't flagged, so callers can drop it
 * inline without conditionals.
 */
export default function ExplicitBadge({ explicit, trackId, size = "sm" }) {
  if (!explicit) return null;
  const cls =
    size === "xs"
      ? "h-3.5 w-3.5 text-[8px]"
      : "h-4 w-4 text-[9px]";
  return (
    <span
      data-testid={trackId ? `explicit-badge-${trackId}` : "explicit-badge"}
      title="Explicit content"
      aria-label="Explicit"
      className={`inline-flex items-center justify-center shrink-0 bg-red-600 text-white font-mono font-black uppercase tracking-tight ${cls}`}
    >
      E
    </span>
  );
}
